import {getProfileInfo, storePublicView} from "../../api/profile";
import {useMutation, useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import Card from "../../components/UI/Card";
import EmptyImage from "../../components/UI/EmptyImage";
import LogoUploadComponent from "../../views/profile-settings/LogoUploadComponent";
import ProfileInfoUpdateComponent from "../../views/profile-settings/ProfileInfoUpdateComponent";
import Button from "../../components/UI/Button";
import {getCommissionBalanceInfo} from "../../api/commissionTransaction";
import {checkPermission} from "../../util/auth";
import {useNavigate} from "react-router";

const ProfileSettings = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['STORE_INFO_READ'])){
      navigate("/no-access");
    }
  }, [navigate]);
  const [vendor, setVendor] = useState(null);
  const [openLogoModal, setOpenLogoModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(null);
  const [updateColumn, setColumn] = useState(null);
  const [commissionInfo, setCommissionInfo] = useState(null);

  const {mutate, isPending} = useMutation({
    mutationFn: () => getProfileInfo(),
    onSuccess: (data) => {
      setVendor(data)
    }
  })

  const {data: commissionBalance} = useQuery({
    queryKey: ['commissionBalance'],
    queryFn: () => getCommissionBalanceInfo(),
    initialData: () => []
  })

  useEffect(() => {
    if (commissionBalance !== undefined) {
      setCommissionInfo(commissionBalance);
    }
  }, [commissionBalance])

  useEffect(()=>{
    if(!vendor){
      mutate();
    }
  }, [vendor])

  const handleModalOpenClick = (column) => {
    setColumn(column)
    setOpenInfoModal(true)
  }
  const previewStore = (event) => {
    storePublicView().then(r => {
     if(r && r.url){
       window.open( r.url, '_blank');
     }
    })
  }

  return (
    <>
      <Card title={`${vendor ? vendor.name : 'Vendor Profile'}`} cardCls={'border_none'} cardBodyCls={'p_0'}>
        <div className="row">
          <div className="col_4">
            <div className="card checkout_summery height_full">
              <div className="card_body pt_10 pb_0">
                <h1 className="common_sub_title custom_border_bottom  mt_0 mb_5">Store Information</h1>
                {vendor &&
                <table className="table border_none mb_0">
                  <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{vendor.name}
                      {checkPermission(['STORE_INFO_UPDATE']) &&
                        <span onClick={() => handleModalOpenClick('name')}
                              className={'btn has_border_radius btn_transparent btn_sm ml_10'}>
                          <i className="far fa-edit"></i></span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      {vendor.email}
                      {checkPermission(['STORE_INFO_UPDATE']) &&
                      <span onClick={() => handleModalOpenClick('email')}
                            className={'btn has_border_radius btn_transparent btn_sm ml_10'}>
                        <i className="far fa-edit"></i></span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Legal Business Name </td>
                    <td>{vendor.legal_business_name}</td>
                  </tr>
                  <tr>
                    <td>Store Link</td>
                    <td>
                      <Button text={'Open'} classes={'has_border_radius '} variant={'btn_transparent'} size={'btn_sm'} onClickHandler={(e)=>previewStore(e)} />
                    </td>
                  </tr>
                  <tr>
                    <td>Logo</td>
                    <td>
                      {vendor.logo ? <img src={vendor.logo} className={"width_150p"} alt=""/> :
                        <EmptyImage classes={"width_150p"}/>
                      }
                      {checkPermission(['STORE_INFO_UPDATE']) &&
                        <span onClick={() => setOpenLogoModal(true)}
                            className={'btn has_border_radius btn_transparent btn_sm ml_10'}>
                          <i className="far fa-edit"></i></span>
                      }
                      </td>

                  </tr>
                  <tr>
                    <td>Commission Rate</td>
                    <td>{vendor.commission}%</td>
                  </tr>
                  </tbody>
                </table>
                }
              </div>
            </div>
          </div>
          <div className="col_4">
            <div className="card checkout_summery height_full">
              <div className="card_body pt_10 pb_0">
                <h1 className="common_sub_title custom_border_bottom  mt_0 mb_5">
                  Account's Information
                </h1>
                {vendor &&
                <table className="table border_none mb_0">
                  <tbody>
                  <tr>
                    <td>Total Commission</td>
                    <td>${commissionInfo?.total_commission?.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Total Withdraw</td>
                    <td>-${commissionInfo?.total_withdraw?.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Withdraw Pending</td>
                    <td>-${commissionInfo?.pending_withdraw?.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Available balance</td>
                    <td>${commissionInfo?.withdrawable_amount?.toFixed(2)}</td>
                  </tr>
                  </tbody>
                </table>
                }
              </div>
            </div>
          </div>
          <div className="col_4">
            <div className="card checkout_summery height_full">
              <div className="card_body pt_10 pb_0">
                <h1 className="common_sub_title mt_0 mb_5 custom_border_bottom ">
                  Address
                </h1>
                {vendor &&
                <table className="table border_none mb_0">
                  <tbody>
                  <tr>
                    <td>Address</td>
                    <td>{vendor.address}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{vendor.city}</td>
                  </tr>
                  <tr>
                    <td>Post Code </td>
                    <td>{vendor.postal_code}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{vendor.phone}</td>
                  </tr>
                  </tbody>
                </table>
                }
              </div>
            </div>
          </div>
        </div>
      </Card>
      <LogoUploadComponent openModal={openLogoModal} setOpenModal={setOpenLogoModal} setUpdateData={setVendor} />
      {openInfoModal &&
      <ProfileInfoUpdateComponent openModal={openInfoModal} setOpenModal={setOpenInfoModal} setUpdateData={setVendor} column={updateColumn} vendor={vendor} /> }
    </>
  );
}

export default ProfileSettings;